import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Il importe ton cerveau App.js
import './index.css';     // Il charge le design Tailwind/CSS de l'Empire

/**
 * 🛰️ SAHELGUARD ROOT BOOTLOADER
 * Injection de l'architecture Yarmotek dans le DOM.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);